const useParams = (param: string) => {
  const searchParams = new URLSearchParams(window.location.search)
  const urlParam = searchParams.get(param)
  return urlParam ?? ''
}

export default useParams
